import { atom } from 'jotai';

export const mobileAtom = atom(false);
